import dashSocialIconBlack from '@/assets/images/dashsocial/dash-social-icon-black.svg';
import dashSocialIconPrimary from '@/assets/images/dashsocial/dash-social-icon-primary.svg';
import dashSocialIconWhite from '@/assets/images/dashsocial/dash-social-icon-white.svg';
import dashSocialLogoBlack from '@/assets/images/dashsocial/dash-social-logo-black.svg';
import dashSocialLogoPrimaryBlack from '@/assets/images/dashsocial/dash-social-logo-primary-black.svg';
import dashSocialLogoPrimaryWhite from '@/assets/images/dashsocial/dash-social-logo-primary-white.svg';
import dashSocialLogoWhite from '@/assets/images/dashsocial/dash-social-logo-white.svg';

/**
 * `Object.defineProperties` getters are invisible to TypeScript's inference,
 * so the full shape is declared here explicitly.
 *
 * @type {{
 *   appName: string;
 *   abbreviated: string;
 *   logoPrimary: string;
 *   iconPrimary: string;
 *   iconPlaceholder: string;
 *   logoPrimaryWhite: string;
 *   logoBlack: string;
 *   logoWhite: string;
 *   iconBlack: string;
 *   iconWhite: string;
 * }}
 */
export const brandingDashSocial = Object.defineProperties(
  {
    appName: 'Dash Social',
    abbreviated: 'Dash',
  },
  {
    logoPrimary: {
      get: () => dashSocialLogoPrimaryBlack,
      enumerable: true,
    },
    iconPrimary: {
      get: () => dashSocialIconPrimary,
      enumerable: true,
    },
    iconPlaceholder: {
      get: () => dashSocialIconPrimary,
      enumerable: true,
    },

    // These are alternate variants of the branding that are currently unused
    logoPrimaryWhite: {
      get: () => dashSocialLogoPrimaryWhite,
      enumerable: true,
    },
    logoBlack: {
      get: () => dashSocialLogoBlack,
      enumerable: true,
    },
    logoWhite: {
      get: () => dashSocialLogoWhite,
      enumerable: true,
    },

    iconBlack: {
      get: () => dashSocialIconBlack,
      enumerable: true,
    },
    iconWhite: {
      get: () => dashSocialIconWhite,
      enumerable: true,
    },
  },
);
